// src/layout/Layout.jsx
import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import QuotePopup from "../components/QuotePopup";
import { usePopup } from "../context/PopupContext";

const Layout = () => {
  const { pathname } = useLocation();
  const { openPopup } = usePopup();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (!document.querySelector('script[src="https://web3forms.com/client/script.js"]')) {
      const script = document.createElement("script");
      script.src = "https://web3forms.com/client/script.js";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-[#111111] text-[#f1f1f1]">
      <Header onContactClick={openPopup} />

      <div className="bg-[#C6A564] text-[#111111] text-center py-2 text-sm font-medium tracking-wide shadow-md">
        🚧 This website is still under construction — updates and changes are happening regularly.
      </div>

      <main className="flex-grow animate-fadeIn">
        <Outlet />
      </main>

      <Footer />
      <QuotePopup />

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/447494184775"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 bg-[#C6A564] hover:bg-[#d8b971] text-[#111111] p-4 rounded-full shadow-lg transition animate-pulse"
        title="Chat with us on WhatsApp"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 24 24"
          className="w-6 h-6"
        >
          <path d="M16.65 13.38c-.27-.13-1.63-.8-1.88-.89-.25-.09-.43-.13-.62.13-.19.25-.71.88-.87 1.07-.16.19-.32.21-.59.08-.27-.13-1.14-.42-2.17-1.34-.8-.72-1.34-1.6-1.5-1.86-.16-.27-.02-.41.12-.54.13-.13.27-.32.4-.48.13-.16.18-.27.27-.46.09-.19.04-.35-.02-.48-.06-.13-.62-1.49-.85-2.04-.22-.54-.44-.47-.62-.48h-.53c-.19 0-.48.07-.73.35-.25.27-.96.94-.96 2.29 0 1.35.99 2.66 1.13 2.84.13.19 1.95 2.98 4.72 4.18.66.29 1.18.46 1.58.59.66.21 1.26.18 1.74.11.53-.08 1.63-.66 1.86-1.3.23-.64.23-1.18.16-1.3-.06-.13-.25-.19-.52-.32z" />
          <path d="M12 2.04c-5.52 0-10 4.48-10 10 0 1.77.46 3.49 1.34 5.02L2 22l5.11-1.31a9.96 9.96 0 0 0 4.89 1.27h.01c5.52 0 10-4.48 10-10 0-2.67-1.04-5.18-2.93-7.07A9.96 9.96 0 0 0 12 2.04zm0 18.02c-1.52 0-3.01-.38-4.34-1.11l-.31-.17-3.03.78.81-2.96-.2-.3a8.13 8.13 0 0 1-1.25-4.33c0-4.5 3.66-8.16 8.16-8.16 2.18 0 4.23.85 5.77 2.39a8.13 8.13 0 0 1 2.39 5.77c0 4.5-3.66 8.16-8.16 8.16z" />
        </svg>
      </a>

      {/* Instagram Floating Button */}
      <a
        href="https://instagram.com/seguratech_uk"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 left-6 z-50 bg-[#C6A564] hover:bg-[#d8b971] text-[#111111] p-4 rounded-full shadow-lg transition animate-pulse"
        title="Visit us on Instagram"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 24 24"
          className="w-6 h-6"
        >
          <path d="M7 2C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5H7zm10 2c1.654 0 3 1.346 3 3v10c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3h10zm-5 3c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm0 2c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm4.5-3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" />
        </svg>
      </a>
    </div>
  );
};

export default Layout;
